const splitNumberByQuoter = (num) => {
  const quoter = num / 4;
  return [num, num - quoter, num - (2 * quoter), num - (3 * quoter), 0];
};

export default splitNumberByQuoter;
